import React from 'react';

export function customOptionTerminologyVersion({ terminologyVersions }, style) {
  return (
    <div style={style}>
      {terminologyVersions?.map(({ type, version }, i) => {
        const name = type.replace('Terminology', '');
        return <span key={i}>{`${name} ${version}`} </span>;
      })}
    </div>
  );
}
